import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ContenutoGenericoService} from 'src/app/service/contenuto-generico.service';
import {ContenutoGenerico} from 'src/app/model/contenuto-generico';
import {Search} from 'src/app/common/search';
import {AllegatoService} from 'src/app/service/allegato.service';
import {Allegato} from 'src/app/model/allegato';

@Component({
    selector: 'app-picture-gallery',
    templateUrl: './picture-gallery.component.html',
    styleUrls: ['./picture-gallery.component.css']
})
export class PictureGalleryComponent implements OnInit, OnChanges {
    @Input() element: ContenutoGenerico;

    public allegato: Allegato;
    public componentiCollegati: Array<ContenutoGenerico>;
    public loading = true;
    lingua: string;

    constructor(private contenutoService: ContenutoGenericoService,
                private allegatoService: AllegatoService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.lingua = this.element.lang;
        this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
        if (this.element) {
            if (this.element.contenitore != null) {
                this.contenutoService.search._.contenitore = this.element.contenitore;
            } else {
                this.contenutoService.search._contains.contenitore = this.element.uuid;
            }

            this.contenutoService.search._sort = 'ordine ASC';
            this.contenutoService.search._.lang = this.lingua;
            this.contenutoService.getAllList().subscribe(componentiCollegati => {
                    this.componentiCollegati = componentiCollegati;
                    this.loading = false;
                    this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                },
                err => {
                    this.loading = false;
                    this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                });
        }
    }

    ngOnInit() {
    }

}
